import { FontAwesomeIcon } from 'module/ui/components/atoms/icon/icon';
import { CenterAlignedBox } from 'module/ui/components/atoms/layout/layout';
import { Short01 } from 'module/ui/components/styles';
import { faFolder, faGlobe, faLink } from '@fortawesome/pro-regular-svg-icons';
import { KnowledgeBaseTreeFolderType } from 'api/knowledge-base/types';
import { PageType } from 'api/page-template/types';
import { FC } from 'react';
import styled from 'styled-components';
import {
  getIconForAiPageType,
  getIconForFileType,
} from '../../file-viewer/icon-for-file-type';
import { FolderItem } from '../types';

const Name = styled.span`
  ${Short01};
`;

const getIconForFolder = (type: KnowledgeBaseTreeFolderType) => {
  switch (type) {
    case 'DEFAULT':
      return faFolder;
    case 'API_DOC':
      return faLink;
    case 'WEBSITE':
      return faGlobe;
    default:
      return faFolder;
  }
};

export const NameCell: FC<{
  data: FolderItem;
  showFile?: (data: FolderItem) => void;
}> = ({ data, showFile }) => {
  return (
    <CenterAlignedBox
      onClick={() => {
        showFile?.(data);
      }}
    >
      <FontAwesomeIcon
        icon={
          data.type === 'folder'
            ? getIconForFolder(
                data.actualContentType as KnowledgeBaseTreeFolderType,
              )
            : data.actualContentType === 'AI_PAGE'
              ? getIconForAiPageType(data.contentType as PageType)
              : getIconForFileType(data.name)
        }
        size={16}
      />
      <Name>{data.name}</Name>
    </CenterAlignedBox>
  );
};
